import React from 'react';
import moment, { Moment } from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownLong, faArrowUpLong } from '@fortawesome/pro-regular-svg-icons';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import ThreeDotsDropdown from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdown';
import { ThreeDotsDropdownOption } from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdownOption';
import { ServiceRate } from '@spike/boarding-rule-model';
import styles from './RateTableRow.module.scss';

interface RateTableRowProps {
    serviceRate: ServiceRate;
    defaultPrice: number;
    getActionOptions: (serviceRate: ServiceRate) => ThreeDotsDropdownOption[];
}

const formatCurrency = (amount?: number): string => {
    if (amount === undefined || amount === null) return '—';
    return `$${amount.toFixed(2)}`;
};

const formatDate = (date: moment.Moment): string => {
    return moment.utc(date).format('ddd, D MMM YYYY');
};

export const RateTableRow: React.FC<RateTableRowProps> = ({ serviceRate, defaultPrice, getActionOptions }) => {
    const rateAmount = Number(serviceRate.rateItem.amount);
    const isIncrease = rateAmount > defaultPrice;
    const isDecrease = rateAmount < defaultPrice;

    const isExpired = () => {
        return moment().isAfter(serviceRate.rate.endDate);
    };

    return (
        <TableRow>
            <TableCell>
                {formatDate(serviceRate.rate.startDate)} - {formatDate(serviceRate.rate.endDate)}
                {isExpired() && <span className={styles.expired}>Expired</span>}
            </TableCell>
            <TableCell>
                <div className={styles.priceCell}>
                    <span className={styles.priceValue}>{formatCurrency(rateAmount)}/Night</span>
                    {isDecrease && (
                        <FontAwesomeIcon
                            icon={faArrowDownLong}
                            className={styles.decreaseIcon}
                        />
                    )}
                    {isIncrease && (
                        <FontAwesomeIcon
                            icon={faArrowUpLong}
                            className={styles.increaseIcon}
                        />
                    )}
                </div>
            </TableCell>
            <TableCell
                isActions
                onClick={e => e.stopPropagation()}
            >
                <div className={styles.actionsDropdown}>
                    <ThreeDotsDropdown
                        options={getActionOptions(serviceRate)}
                        direction="down"
                    />
                </div>
            </TableCell>
        </TableRow>
    );
};
